import { Dispatch, MutableRefObject, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  HomeSearch,
  Card,
  Services,
  Wrapper,
  Solicitar,
  LinkToCreateRequest,
} from "../../components/MarketPlace/MarketPlaceElements";

import helppeopleIcon from "../../assets/images/Logo-helppeople-2021-favicon.png";

import { LupaBuscar } from "../../components/svg/LupaBuscar";

import { Navigation } from "react-minimal-side-navigation";
import "react-minimal-side-navigation/lib/ReactMinimalSideNavigation.css";

import {
  getServices,
  marketPlace,
  setSelectedProduct,
} from "../../store/modules/MarketPlaceStore";

import { searchTermTimeout } from "../../utils/TimeOut";

import { MarketPlaceProduct } from "../../interfaces/MarketPlaceProduct";
import { MarketPlaceService } from "../../interfaces/MarketPlaceService";
import { Link } from "react-router-dom";

import { request,getParameter } from "../../store/modules/RequestStore";
import { useTranslation } from "react-i18next";
import TranslatableText from "../../components/Multilanguage/TranslatableText";

const MarketPlace = () => {
  const dispatch: Dispatch<any> = useDispatch();
 const [activoBtn, setActivoBtn] = useState(false);
  const marketPlaceState = useSelector(marketPlace);
  const configurationSelf = useSelector(request);

  const searchTimeout: MutableRefObject<any> = useRef();

  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getServices());
    dispatch(setSelectedProduct(null));
  }, [dispatch]);
useEffect(() => {
        const fetchParameter = async () => {
          const paramShowLang = await getParameter({ parameterName: "BotonCrearSolicitud" });
          if (
            paramShowLang?.data?.status === "Ok" &&
            paramShowLang.data.values.parameterValue.toString() === "1"
          ) {
            setActivoBtn(true);
          } 
        };
    
        fetchParameter();
      }, []);
  const [selectedServiceIndex, setSelectedServiceIndex] = useState(0);

  const getIndexOfService = (selectedServiceId: number): number => {
    let indexOfService = -1;

    marketPlaceState.services.every(
      (service: MarketPlaceService, index: number) => {
        service.products.every((product: MarketPlaceProduct) => {
          if (product.ProductServiceId === selectedServiceId) {
            indexOfService = index;
            return false;
          }

          return true;
        });

        if (indexOfService !== -1) return false;

        return true;
      }
    );

    return indexOfService;
  };

  const getSelectedProduct = (
    productId: number
  ): MarketPlaceProduct | undefined => {
    const selectedProduct = marketPlaceState.services[
      selectedServiceIndex
    ].products.find((product: MarketPlaceProduct) => {
      return product.ProductId === productId;
    });

    return selectedProduct;
  };

  const handleProductDescription = (description: string) => {
    if (description.length > 39) return <TranslatableText text={description.slice(0, 40) + "..."} />;

    return <TranslatableText text={description} />;
  };

  const handleProductSearch = (searchTerm: string) => {
    // Se limpia el tiempo (timeout) de la búsqueda anterior
    clearTimeout(searchTimeout.current);
   
    searchTimeout.current = setTimeout(() => {
      dispatch(getServices(searchTerm));
      if(marketPlaceState.navbarServices.length > 0) {
        getIndexOfService(Number.parseInt(marketPlaceState.navbarServices[0].itemId))
        setSelectedServiceIndex(0);
      }
    }, searchTermTimeout);
  };

  const productImageStyle: any = {
    borderRadius: "50%",
    maxWidth: "100%",
    maxHeight: "100%",
    aspectRatio: "1",
  };

  return (
    <>
      <div>
        {" "}
        {configurationSelf.selfServiceConfiguration.activateNewRequest ===
          false && activoBtn && (
          <LinkToCreateRequest to="/request/new">
            {t("marketplace.notFound")}
          </LinkToCreateRequest>
        )}
      </div>
      <Wrapper>
        <Services>
          <Link to={"/"}>
            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 17L6 12M6 12L11 7M6 12L18 12"
                stroke="#111827"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
          <div className="w-full pb-2 my-6 flex justify-end">
            <form
              className="sm:w-full relative"
              onSubmit={(e: any) => e.preventDefault()}
            >
              <HomeSearch
                type="search"
                name="search"
                placeholder={t("marketplace.inputSearch")}
                className="bg-inherit h-10 px-5 pr-10 rounded-full text-sm focus:outline-none w-full"
                onChange={(e: any) => handleProductSearch(e.target.value)}
              />
              <button type="submit" className="absolute right-4 top-3">
                <LupaBuscar />
                {}
              </button>
            </form>
          </div>

          <Navigation
            onSelect={(e: any) => {
              
              const selectedServiceId: number = Number.parseInt(e.itemId);
              
              const serviceIndex: number = getIndexOfService(selectedServiceId);
              
              if (serviceIndex !== -1) setSelectedServiceIndex(serviceIndex);
            }}
            items={marketPlaceState.navbarServices.map((data) => {
              return {...data, title: <TranslatableText text={data.title} /> as any}
            }) || []}
            activeItemId={marketPlaceState.navbarServices.length > 0 ? marketPlaceState.navbarServices[0].itemId : ''} 
          />
        </Services>

        <div className="wraper" style={{ display: "flex", flexWrap: "wrap" }}>
          <div className="grid grid-cols-4" style={{ height: "500px" }}>
            {marketPlaceState.services[selectedServiceIndex] &&
            marketPlaceState.services.length > 0 &&
            marketPlaceState.services[selectedServiceIndex].products.length >
              0 ? (
              marketPlaceState.services[selectedServiceIndex].products.map(
                (product: MarketPlaceProduct) => {
                  return (
                    <div
                      key={product.ProductId}
                      className="justify-content-md-center p-6"
                    >
                      <Card
                        className={`w-full p-3 border border-gris rounded-lg bg-white`}
                      >
                     
                        <div className="flex justify-between">
                          <img
                            src={
                              product.ProductImage !== ""
                                ? product.ProductImage
                                : "https://s3.us-west-2.amazonaws.com/developer.helppeoplecloud.com/Logo-helppeople-2021-favicon.png"
                            }
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null;
                              currentTarget.src = helppeopleIcon;
                            }}
                            alt="productImage"
                            style={productImageStyle}
                          />
                        </div>
                        <div
                          onClick={() => {
                            const selectedProduct = getSelectedProduct(
                              product.ProductId
                            );

                            if (selectedProduct)
                              dispatch(setSelectedProduct(selectedProduct));
                          }}
                          className="font-request "
                        >
                          <Solicitar to="./requestMarketPlace">
                            <p className="font-txt-request">{t("marketplace.buttonRequest")}</p>
                          </Solicitar>
                        </div>
                        <p className="fonttitle">
                          <span
                            style={{
                              wordWrap: "break-word",
                            }}
                            className="title"
                          >
                            <TranslatableText text={product.ProductName} />
                          </span>
                        </p>
                        {/* Descripción producto */}
                        <p
                          className="font-description mb-2"
                          style={{
                            overflowWrap: "break-word",
                            width: "90%",
                            overflow: "hidden",
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          <span className="font-body">
                            {handleProductDescription(
                              product.ProductDescription
                            )}
                          </span>
                        </p>
                        {/* Costo */}
                        <p
                          className="font-price"
                          style={{
                            display: product.ProductVisibleCost
                              ? "contents"
                              : "none",
                          }}
                        >
                          <span className="price">
                            {product.ProductCost.toLocaleString("es-CO", {
                              style: "currency",
                              currency: "COP",
                              minimumFractionDigits: 0,
                            })}
                          </span>
                        </p>
                      </Card>
                    </div>
                  );
                }
              )
            ) : (
              <div>
                {/* TODO: Crear layout informativo cuando no hay elementos por mostrar*/}
                <h4>{<TranslatableText text={"Sin elementos"} />}</h4>
              </div>
            )}
          </div>
        </div>
      </Wrapper>
      {/* <div>
        <Footer />
      </div> */}
    </>
  );
};

export default MarketPlace;
